const list = {
  // =================================================================================================================
  components() {
    return [
      // ===========[ 날짜 관련 ]==========
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          unit: "",
          afterFix: "년",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "예산", "집행률(%)", "집행실적", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    if (search.month) {
      conditions.push({ key: "header.month", operator: "=", value: search.month });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "업체명",
        key: "body.업체명",
      },
      {
        name: "예산",
        key: "body.관리비.예산",
      },
      {
        name: "집행률(%)",
        key: "body.관리비.집행률",
      },
      {
        name: "집행실적",
        key: "body.관리비.집행실적",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 3 || index === 5) {
          return func.comma(func._getCol(index, value, func));
        }
        if (index === 4) {
          const data = `${func._getCol(index, value, func)}` || "0";
          // 소수점 2자리로 반환한다
          return `${((data * 100) / 100).toFixed(2)}%`;
        } else {
          return func._getCol(index, value, func) || "-";
        }
      }
    } catch (e) {}
    return "";
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};

export default list;
